<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-03-26 
-->
<template>
  <div class="index">
    <div class="header">
      <img :src="custom_report_detail.logo_path | logo_show" class="logo-img" @click="goback">
      <a @click="goback">返回首页</a>
    </div>
    <div class="search-container">
      <div class="search-ipt">
        <i class="iconfont search-icon">&#xe6d7;</i>
        <Input v-model="params.keyword" @on-enter="handleRefreshList" placeholder="搜索标题、内容、实体、政策、适应症" />
        <Button @click="handleRefreshList">搜索</Button>
      </div>
    </div>
    <!-- 筛选条件部分 -->
    <div class="filter-section">
      <div class="filter-row">
        <div class="filter-item active" @click="showSortPicker = true">
          <span>{{params.sort_type | dealName(sorts)}}</span>
          <Icon type="md-arrow-dropdown" />
        </div>
        <div class="filter-item active" @click="showSearchTypePicker = true">
          <span>{{params.search_type | dealName(search_types)}}</span>
          <Icon type="md-arrow-dropdown" />
        </div>
        <div :class="['filter-item', params.start_time && 'active']" @click="showDateRange = true">
          <span v-if="!params.start_time">时间段筛选</span>
          <span v-else>{{params.start_time}}至{{params.end_time}}</span>
          <Icon type="md-arrow-dropdown" />
        </div>
        <div :class="['filter-item', params.module_ids.length && 'active']" @click="showModulePicker = true">
          <span v-if="!params.module_ids.length">栏目筛选</span>
          <span v-else>{{params.module_ids | dealArrayName(categories)}}</span>
          <Icon type="md-arrow-dropdown" />
        </div>
      </div>
    </div>
    <div class="search-result-container">
      <div class="result-list">
        <div class="result-item" v-for="(item, index) in list" :key="index">
          <div class="result-item-top">
            <div class="result-item-img" v-if="item.content_type != '0'" @click="handleClickItem(item.src_url)">
              <img :src="item.logo_path | logo_show" />
            </div>
            <img :src="$store.state.static_img_url + 'pic/briefReport/slash.png'" class="slash" v-if="item.content_type == '0'">
            <div class="item-title" v-html="filter.keyWordHighLight(item.title, currentKeyword)" @click="handleClickItem(item.src_url)"></div>
          </div>
          <div class="result-item-content">
            <div class="item-content" v-html="filter.keyWordHighLight(item.content, currentKeyword)"></div>
            <div class="item-footer">
              <span class="time">{{item.publish_time | time_moment('YYYY-MM-DD')}}</span>
              <span class="period">第{{item.chapter_num}}期 {{item.chapter_title}}</span>
            </div>
          </div>
        </div>
        <div class="no-data" v-if="!list.length && !loading">
          <img :src="$store.state.static_img_url + 'pic/newsletter/nodata-icon.png'" />
          <p>没有找到相关的内容</p>
        </div>
        <div class="no-data2" v-if="list.length && !more && !loading">已经到底了</div>
        <Spin v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <div ref="indexlist-bottom"></div>
    </div>
    <Spin fix v-if="pageLoading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <BackTop></BackTop>
    <van-popup v-model="showSearchTypePicker" round position="bottom" @open="openSearchTypePicker">
      <van-picker show-toolbar ref="search-type-picker" :columns="search_types" value-key="name" @cancel="showSearchTypePicker = false" @confirm="onSearchTypeConfirm" />
    </van-popup>
    <van-popup v-model="showSortPicker" round position="bottom" @open="openSortPicker">
      <van-picker show-toolbar ref="sort-picker" :columns="sorts" value-key="name" @cancel="showSortPicker = false" @confirm="onSortConfirm" />
    </van-popup>
    <van-calendar v-model="showDateRange" ref="date-range" type="range" :min-date="minDate" :max-date="maxDate" color="#FA5A00" allow-same-day @select="selectDateRange" @open="openCalendar">
      <template slot="title">
        <span>日期选择</span>
        <div class="month-btns">
          <van-button size="mini" @click="handleChangeYear('prev')">
            <i class="iconfont-pc30">&#xe639;</i>
          </van-button>
          <van-button size="mini" @click="handleChangeYear('next')">
            <i class="iconfont-pc30">&#xe63a;</i>
          </van-button>
        </div>
      </template>
      <template slot="top-info" slot-scope="row">
        <span v-if="filter.time_moment(row.date, 'YYYY-MM-DD') == filter.time_moment(new Date(), 'YYYY-MM-DD')" class="today">今日</span>
      </template>
      <div class="calendar-btns" slot="footer">
        <van-button round @click="clearDateRange" color="#AEAEAE">
          {{!params.start_time ? '取消' : '删除时间段'}}
        </van-button>
        <van-button round :disabled="!dateRange.length" color="#FA5A00" @click="handleConfirmDateRange">
          {{!dateRange.length ? '请选择结束时间' : '确定'}}
        </van-button>
      </div>
    </van-calendar>
    <van-popup v-model="showModulePicker" round position="bottom" @open="openModulePicker">
      <div class="van-picker__toolbar">
        <button type="button" class="van-picker__cancel" @click="clearModule">清空</button>
        <button type="button" class="van-picker__confirm" @click="onModuleConfirm">确认</button>
      </div>
      <van-checkbox-group v-model="moduleIds" class="categories-checkbox">
        <van-cell-group>
          <van-cell :name="item.id" v-for="item,index in categories" :key="item.id" clickable :title="item.name" @click="toggle(index)">
            <template slot="right-icon">
              <van-checkbox :name="item.id" ref="checkboxes" checked-color="#FA5A00" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
  </div>
</template>
<script>
import { getReportContent, privatereport, getCustomReportContentList } from '@/service'
import moment from 'moment'
import filter from 'js/filter'

export default {
  components: {},
  created() {
    this.params.keyword = this.$route.query.keyword
      ? decodeURIComponent(this.$route.query.keyword)
      : ''

    if (this.$route.query.uid && this.$route.query.name) {
      this.getCustomReportDetail()
    } else {
      this.$Message.error('链接参数错误！')
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        const listbox = this.$refs['indexlist-bottom']
        const listrect = listbox.getBoundingClientRect()
        const listabsoluteTop = listrect.top + scrollTop
        if (
          scrollTop + windowHeight > listabsoluteTop &&
          scrollTop > 0 &&
          !this.loading &&
          this.more
        ) {
          this.handleMore()
        }
      }, 10)
    })
  },
  beforeDestroy() {
    window.onscroll = ''
  },
  data() {
    return {
      filter,
      pageLoading: true,
      loading: false,
      more: false,
      custom_report_detail: {},
      dateRange: [],
      chapter_ids: [],
      categories: [],
      params: {
        chapter_ids: [], //【期刊id数组】
        start_time: '', //【开始时间】
        end_time: '', //【结束时间】
        uid: this.$route.query.uid, //【所属月报uid】
        page: 1,
        size: 30,
        module_ids: [], //【栏目id数组】
        keyword: '', //【关键词】
        sort_type: '2', //【排序方式，1时间降序（默认），2相关度降序】
        search_type: '0',
      },
      list: [],
      currentKeyword: '',
      showSearchTypePicker: false,
      search_types: [
        {
          name: '搜索标题',
          id: '0',
        },
        {
          name: '全文检索',
          id: '1',
        },
      ],
      showSortPicker: false,
      sorts: [
        {
          name: '相关度降序',
          id: '2',
        },
        {
          name: '时间降序',
          id: '1',
        },
      ],
      showDateRange: false,
      minDate: new Date(2014, 0, 1),
      maxDate: new Date(),

      moduleIds: [],
      showModulePicker: false,
    }
  },
  computed: {},
  methods: {
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    /**
     * 获取简报和期刊信息
     */
    async getCustomReportDetail() {
      let res = await privatereport(
        {
          uid: this.$route.query.uid,
          name: this.$route.query.name,
        },
        (error) => this.$Message.error('请求错误！')
      )
      this.pageLoading = false
      if (res.status == 'success') {
        this.$set(this.$data, 'custom_report_detail', res.res[0])
        this.chapter_ids = res.chapter.map((item) => item.id)
        this.getReportContent()
        this.handleRefreshList()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getReportContent() {
      let res = await getReportContent(
        {
          start_time: '',
          end_time: '',
          chapter_ids: this.chapter_ids,
        },
        (error) => this.$Message.error('请求错误！')
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'categories', res.res)
      } else {
        this.$Message.error('请求错误！')
      }
    },
    async getCustomReportContentList() {
      this.loading = true
      this.currentKeyword = this.params.keyword
      if(!this.currentKeyword) {
        this.list = []
        this.params.page = 1
        this.loading = false
        return
      }
      let res = await getCustomReportContentList(this.params, (error) =>
        this.$Message.error('请求错误！')
      )
      this.loading = false
      if (res.status == 'success') {
        this.list = [...this.list, ...res.res]
        this.more = res.res.length == 30
      } else {
        this.$Message.error('请求错误！')
      }
    },
    handleRefreshList() {
      this.params.page = 1
      this.list = []
      this.getCustomReportContentList()
    },
    handleMore() {
      this.params.page++
      this.getCustomReportContentList()
    },
    handleExport() {},
    goback() {
      const { uid, name } = this.$route.query
      this.$router.push({
        name: 'MNewsletter',
        query: {
          uid,
          name,
        },
      })
    },
    handleClickItem(src_url) {
      window.open(src_url, '_blank')
    },
    openSearchTypePicker() {
      this.$nextTick(() => {
        let index = this.search_types.findIndex((item) => item.id === this.params.search_type)
        this.$refs['search-type-picker'].setIndexes([index])
      })
    },
    onSearchTypeConfirm(row) {
      this.params.search_type = row.id
      this.showSearchTypePicker = false
      this.handleRefreshList()
    },
    openSortPicker() {
      this.$nextTick(() => {
        let index = this.sorts.findIndex((item) => item.id === this.params.sort_type)
        this.$refs['sort-picker'].setIndexes([index])
      })
    },
    onSortConfirm(row) {
      this.params.sort_type = row.id
      this.showSortPicker = false
      this.handleRefreshList()
    },
    openCalendar() {
      const [start, end] = [this.params.start_time, this.params.end_time]
      if (start && end) {
        this.dateRange = [start, end]
        this.$refs['date-range'].reset([
          new Date(moment(start).format('YYYY/MM/DD')),
          new Date(moment(end).format('YYYY/MM/DD')),
        ])
      } else {
        this.dateRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
        this.$refs['date-range'].reset([new Date(), new Date()])
      }
      this.handleChangeScrollTop()
    },
    handleChangeScrollTop() {
      this.$nextTick(() => {
        const calendarDom = document.querySelector('.van-calendar__body')
        if (calendarDom) {
          let back = calendarDom.scrollTop
          setTimeout(() => {
            back = calendarDom.scrollTop
            calendarDom.scrollTop = back - 2
          }, 10)
          setTimeout(() => {
            calendarDom.scrollTop = back
          }, 100)
        }
      })
    },
    handleChangeYear(name) {
      const calendarSubtitle = this.$refs['date-range'].$el.querySelector(
        '.van-calendar__header-subtitle'
      )
      if (!calendarSubtitle) return

      let year = parseInt(calendarSubtitle.innerText.split('年')[0])

      // 检查年份限制
      if (name === 'prev' && year <= 2014) return
      if (name === 'next' && year >= new Date().getFullYear()) return

      year = name === 'prev' ? year - 1 : year + 1

      this.$nextTick(() => {
        this.$refs['date-range'].scrollToDate(new Date(year, 0, 1))
        this.handleChangeScrollTop()
      })
    },
    selectDateRange(date) {
      const [start, end] = date
      if (start && end) {
        this.dateRange = [moment(start).format('YYYY-MM-DD'), moment(end).format('YYYY-MM-DD')]
      } else {
        this.dateRange = []
      }
    },
    clearDateRange() {
      if(!this.params.start_time) {
        this.showDateRange = false
        return
      }
      this.showDateRange = false
      this.params.start_time = ''
      this.params.end_time = ''
      this.dateRange = []
      this.handleRefreshList()
    },
    handleConfirmDateRange() {
      this.showDateRange = false
      this.params.start_time = this.dateRange[0]
      this.params.end_time = this.dateRange[1]
      this.handleRefreshList()
    },
    openModulePicker() {
      this.moduleIds = this.params.module_ids
    },
    onModuleConfirm() {
      this.showModulePicker = false
      this.params.module_ids = this.moduleIds
      this.handleRefreshList()
    },
    clearModule() {
      this.showModulePicker = false
      this.params.module_ids = []
      this.handleRefreshList()
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~mobile/styles/briefReport.stylus'
@import '~mobile/styles/newsletter.stylus'
.index
  background #FFFFFF
  min-height 100vh
  padding 1.02rem 0 0
  .header
    a
      color #FA5A00
      cursor pointer
      margin-right 0.4rem
.search-container
  padding 0.3rem
  display flex
  justify-content center
  .search-ipt
    margin-top 0
.filter-section
  .filter-row
    display flex
    justify-content space-between
    padding 0.1rem 0.3rem
    .filter-item
      font-size 0.28rem
      color #333333
      display flex
      align-items center
      > span
        max-width 1.6rem
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      .ivu-icon
        font-size 0.32rem
      &.active
        color #FA5A00
.search-result-container
  padding 0.4rem
  .search-filter
    display flex
    align-items center
    justify-content space-between
    padding-bottom 20px
    .filter-item
      margin-right 16px
  .result-list
    .result-item
      margin-bottom 0.6rem
      &-top
        display flex
        position relative
        .slash
          position absolute
          left -0.24rem
          top 0.1rem
          width 0.16rem
          height 0.24rem
      &-img
        overflow hidden
        flex 0 0 2.42rem
        max-width 2.42rem
        min-width 2.42rem
        height 1.52rem
        margin-right 0.2rem
        img
          width 100%
          height 100%
      &-content
        position relative
        margin-top 0.2rem
      .item-footer
        margin-top 0.2rem
        font-size 0.28rem
        color #666
        display flex
        justify-content space-between
      .item-title
        font-weight 700
        color #333
        font-size 0.32rem
        line-height 0.48rem
        cursor pointer
        transition all 0.3s
        &:active
          color #FA5A00
      .item-content
        font-size 0.3rem
        color #333
        line-height 0.48rem
        flex auto
      >>> .high-light
        color #FA5A00
        font-style normal
    .no-data2
      font-size 0.28rem
      color #A5B4E6
      line-height 0.82rem
      text-align center
    .no-data
      padding 1.2rem 0
      line-height 1
      text-align center
      img
        width 0.6rem
        height 0.6rem
        margin-bottom 0.24rem
      p
        font-size 0.28rem
        color #A5B4E6
.calendar-btns
  display flex
  height 50px
  align-items center
  .van-button
    flex 1
    height 36px
    &+.van-button
      margin-left 16px
.categories-checkbox
  overflow auto
  max-height 60vh
  margin-top 0.1rem
.today
  color #FA5A00
>>> .van-calendar
  .van-calendar__day--start, .van-calendar__day--end, .van-calendar__day--start-end
    .today
      color #FFF
  .van-calendar__header-title
    position relative
  .month-btns
    position absolute
    display flex
    justify-content space-between
    height 44px
    z-index 2
    width 100%
    left 0
    right 0
    bottom -44px
    align-items center
    padding 0 20px
    .iconfont-pc30
      font-size 12px
</style>